import React, { memo, useState, useEffect, useRef } from 'react';
import Styles from '../../components/IpConfigurationDropdown.tsx/ipConfigDropDown.module.scss';
import { Input } from 'antd';
import { Loader } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { apiBaseUrl, networkCall } from '../../../../../utils/networkCall';
import { limitStringLength } from '../../../../../utils';

import searchIcon from '../../../../../../src/assets/search.svg';
import upArrow from '../../../../../../src/assets/upArrowBlue.svg';
import downArrow from '../../../../../../src/assets/downArrowBlue.svg';


type configFilterProps = {
	config: any;
	setConfig: (value: any) => void;
	dropDown: boolean;
	setDropDown: (value: any) => void;
	onClose: () => void;
	keyword: (value: any) => void;
};
type config={
	name:string,
	ip_addresses:string
}

const SelectConfigurationDropDown: React.FC<configFilterProps> = ({
	config,
	setConfig,
	dropDown,
	setDropDown,
	onClose,
	keyword
}) => {

	const { t } = useTranslation();
	const history = useHistory();
	const [configurationList, setConfigurationList] = useState<any>([]);
	const [searchText, setSearchText] = useState<any>('');
	const [loading, setLoading] = useState(true);
	const [filteredData, setFilteredData] = useState([]);
	const ref = useRef<any>(null);

	useEffect(() => {
		const endpoint = '/ipconfig?list_all=true';
		let config: config[] = [];
		networkCall('get', `${endpoint}`, apiBaseUrl.baseUrl)
			.then((res: any) => {
				if (res.data) {
					setLoading(false);
					res?.data.map((item: any) => {
						config.push({
							name: item?.ip_config_name,
							ip_addresses: item?.ip_addresses
						})
					})
					setConfigurationList(config);
				} else {
					setLoading(true);
				}
			})
			.catch((error) => {
				setLoading(true);
			});
		return () => {
			setLoading(true);
			setConfigurationList([]);
		}
	}, [])

	useEffect(() => {

		let searchResult = configurationList.filter((value: any) => (value.name.toLowerCase()).includes(searchText.toLowerCase()));

		setFilteredData(searchText ? searchResult : configurationList);
	}, [searchText, configurationList]);

	const useOnClickOutside = (refEl: any, handler: any) => {

		useEffect(() => {
			const listener = (event: any) => {
				if (!refEl.current.contains(event.target)) {
					handler(event);
				}
			};

			document.addEventListener('mousedown', listener);

			return () => {
				document.removeEventListener('mousedown', listener);
			};
		}, [refEl, handler]);
	};

	useOnClickOutside(ref, () => setDropDown(false));

	const handleOnSelect = () => {

		setSearchText('');
		setDropDown((prev :boolean) => !prev);
		if (config) {
			setConfig('');
			setDropDown(false);
		}
	};

	const handleOnAddIpConfig = () => {
		history.push('/developers/ip-configurations');
		onClose();
	}

	return (

		<div ref={ref}>
			<div
				className={config ? Styles.removeConfig : Styles.ipConfig}
				onClick={() => { handleOnSelect() }}
			>
				<span>{config ? t("KLR02697") : t("KLR02698")}</span>
				{
					!config &&
					<img
						src={dropDown ? upArrow : downArrow}
						color='#1676EE'
						style={{ marginLeft: 8, cursor: 'pointer' }}
						alt=''
					/>
				}
			</div>
			{dropDown && (
				<div className={Styles.dropDown}>
					{
						loading ? <Loader />
							:
							<>
								{configurationList.length > 0 ?
									<>
										<Input
											type={'text'}
											placeholder={t("mainSearch")}
											onChange={(e: any) => {
												setSearchText(e.target.value);
											}}
											className={Styles.searchInput}
											suffix={<img src={searchIcon} alt='search' />}
										/>
										{
											filteredData.length > 0 ?
												<>
													{filteredData.map((item: any, index: any) => {
														return (
															<div
																key={index}
																className={Styles.listItems}
																onClick={() => {
																	setConfig(item);
																	setDropDown(false);
																	setSearchText('');
																	keyword(null);
																}}
															>
																{limitStringLength(item.name, 32)}
															</div>
														)
													}
													)}
												</>
												:
												<div className={Styles.noResults}>{t("tableNoResults")}</div>
										}
									</>
									:
									<div className={Styles.nodata}>
										<div>{t("KLR02699")}</div>
										<div className={Styles.addIpConfig} onClick={() => handleOnAddIpConfig()}>{t("KLR02700")}</div>
									</div>
								}
							</>}
				</div>
			)}
		</div>
	);
};

export default memo(SelectConfigurationDropDown);
